import React from 'react';
import { FilterProvider, FilterScope } from "../../contexts/FilterContext";
interface FilterWrapperProps {
  children: React.ReactNode;
  scope: FilterScope;
}

const FilterWrapper = ({ children, scope }: FilterWrapperProps) => {
  return (
    <FilterProvider scope={scope}>
      {children}
    </FilterProvider>
  );
};

export default FilterWrapper; 